import IgirException from './igirException.js';

/**
 * An {@link Error} thrown when an output token fails to be replaced.
 */
export default class TokenReplacementException extends IgirException {}
